export * from "./atoms";
export * from "./molecules";
export * from "./organisms";
export * from "./messages";

import { ProgramAtoms } from "./atoms";
import { ProgramMessages } from "./messages";
import { ProgramMolecules } from "./molecules";
import { ProgramOrganisms } from "./organisms";


export const ProgramComponents = [...ProgramAtoms, ...ProgramMolecules, ...ProgramOrganisms, ...ProgramMessages];
